import Router, { type NextRouter } from 'next/router';

export function getPageFromRouter(router: NextRouter) {
  const { route, query } = router;
  return query && query.extReferenceType === 'HOOGLER'
    ? 'hoogler'
    : route.endsWith('/hotel-only')
      ? 'ho'
      : route.endsWith('/flight-hotel')
        ? 'dp'
        : route.endsWith('/train-hotel')
          ? 'th'
          : route.endsWith('sdp')
            ? 'sem'
            : route.endsWith('/hotel-static')
              ? 'static'
              : route.endsWith('/hotel-reviews')
                ? 'reviews'
                : 'unknown';
}

export function getPage(): Pages {
  return getPageFromRouter(Router);
}

export function getLoggingInfo(page: Pages, service: string, module: string, debug?: boolean): LoggingInfo {
  return {
    tags: { page, service, module, debug: debug || false },
  };
}
